import { Box, useTheme } from "@mui/material";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

import { useFetchZeffyLoaderAnimation } from "@/forms-design-system/FormZeffyLoader/useFetchZeffyLoaderAnimation";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

interface FormZeffyLoaderProps {
  size?: "small" | "medium" | "large";
}

const HEIGHT_BY_SIZE = {
  small: 28,
  medium: 36,
  large: 100,
};

export const FormZeffyLoader = ({ size = "medium" }: FormZeffyLoaderProps) => {
  const theme = useTheme();

  const animationData = useFetchZeffyLoaderAnimation(
    theme.palette.formsComponents?.zeffyLoader?.color ?? "hsl(0, 0%, 0%)" // Should never happen, unless the theme is not set
  );

  if (!theme.palette.forms || !theme.palette.formsComponents?.zeffyLoader) {
    return <InvalidThemeErrorMessage />;
  }

  return (
    <Box
      sx={{
        height: HEIGHT_BY_SIZE[size],
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "& svg": { width: "unset !important" },
      }}
    >
      <Lottie
        options={{ animationData }}
        style={{ height: "inherit" }}
        ariaRole="loader"
        isClickToPauseDisabled={true}
      />
    </Box>
  );
};
